import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "@/hooks/use-toast";
import { Loader2, Mail } from "lucide-react";
import AdminNavigation from "@/components/AdminNavigation";
import AdminFooter from "@/components/AdminFooter";

export function AdminReports() {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateWeeklyReport = async () => {
    setIsGenerating(true);
    try {
      const response = await fetch("/api/admin/generate-weekly-report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error("Failed to generate report");
      }

      const result = await response.json();
      toast({
        title: "Report Generation Started",
        description: result.message || "Weekly reports will be sent to the configured email addresses.",
      });
    } catch (error) {
      console.error("Error generating report:", error);
      toast({
        title: "Error",
        description: "Failed to generate weekly report. Please try again.",
        variant: "destructive",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50" data-testid="admin-reports">
      <AdminNavigation currentPage="Reports" showBackButton={true} />
      
      <div className="max-w-7xl mx-auto p-4 md:p-6 space-y-6 md:space-y-8">
      
      <Card>
        <CardHeader>
          <CardTitle>Weekly Report Generator</CardTitle>
          <CardDescription>
            Generate and send weekly cost analysis and revenue reports to stakeholders
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Reports will be sent to:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>tommy.xaypanya@neuralquantum.ai</li>
              <li>craig.ross@neuralquantum.ai</li>
            </ul>
          </div>
          
          <div className="bg-muted p-4 rounded-lg">
            <h3 className="font-semibold mb-2">Report Contents:</h3>
            <ul className="text-sm space-y-1">
              <li>• Revenue analysis (subscriptions, gift cards, merchandise)</li>
              <li>• Cost breakdown (OpenAI API, storage, server costs)</li>
              <li>• Key metrics (ARPU, churn rate, conversion rate)</li>
              <li>• AI-powered insights and recommendations</li>
              <li>• Growth projections and trends</li>
            </ul>
          </div>

          <Button 
            onClick={generateWeeklyReport} 
            disabled={isGenerating}
            className="w-full"
          >
            {isGenerating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Generating Report...
              </>
            ) : (
              <>
                <Mail className="mr-2 h-4 w-4" />
                Generate Weekly Report Now
              </>
            )}
          </Button>

          <p className="text-xs text-muted-foreground text-center">
            Note: Reports are automatically generated every Monday at 8:00 AM
          </p>
        </CardContent>
      </Card>
      </div>
      <AdminFooter />
    </div>
  );
}